export enum SignatureEventType {
  SESSION_CREATED = 'SESSION_CREATED',

  DOCUMENT_VIEWED = 'DOCUMENT_VIEWED',

  DOCUMENT_SIGNED = 'DOCUMENT_SIGNED',

  DOCUMENT_REJECTED = 'DOCUMENT_REJECTED',

  SESSION_EXPIRED = 'SESSION_EXPIRED',

  SESSION_CANCELLED = 'SESSION_CANCELLED',
}
